import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Icon24SpinnerLarge, Icon24Spinner, Icon16Spinner } from '@figma/fpl-icons/internal';
import clsx from 'clsx';
import { AnnouncementPrimitive } from '../announcement-primitive/announcement-primitive.js';
import { useString } from '../settings/settings.strings.js';
import { srOnly } from '../styles/composables.css.js';
import { spinner, root, size } from './loading-spinner.css.js';

/**
 * A loading spinner indicates when an event is in progress and the user will need to wait.
 * @see https://fpl.figma.design/components/loading/spinner/
 */
const LoadingSpinner = forwardRef(({ loadingText, size: size$1 = 'md', ...props }, ref) => {
    const loadingLabel = useString('loading');
    const UI3Spinner = UI3Spinners[size$1];
    return (jsxs(AnnouncementPrimitive, { "data-fpl-component": "", ...props, className: clsx(root, size[size$1]), ref: ref, children: [jsx("div", { className: srOnly, children: loadingText ?? loadingLabel }), jsx(UI3Spinner, { className: spinner, "aria-hidden": true })] }));
});
LoadingSpinner.displayName = 'LoadingSpinner';
const UI3Spinners = {
    sm: Icon16Spinner,
    md: Icon24Spinner,
    lg: Icon24SpinnerLarge,
};

export { LoadingSpinner };
//# sourceMappingURL=loading-spinner.js.map
